import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

/**
 * Service for interacting with app loader bar
 */
@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private _state: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(){}

    /**
     * Get current loader state
     * @returns {Observable<boolean>} Observable containing current loader state - true = shown, false = hidden.
     */
    public loaderState(): Observable<boolean> {
        return this._state;
    }

    /**
     * Set loader state
     */
    public set shown(state: boolean) {
        this._state.next(state);
    }
}
